import { selectRootUndoRedo, selectUndoRedoAvailability } from "views/logic/slices/undoRedoSelectors";
import { isViewWidgetsEqualForSearch, selectQuery, updateView } from "views/logic/slices/viewSlice";
import { setCurrentRevision } from "views/logic/slices/undoRedoSlice";
import { selectRootView } from "views/logic/slices/viewSelectors";
import isEqualForSearch from "views/stores/isEqualForSearch";
const isViewSearchEqual = (first, second) => isEqualForSearch(first, second);
const viewHandler = (state, {
  hasToPushRevision,
  dispatch,
  currentView
}) => dispatch(selectQuery(state.activeQuery)).then(() => {
  const shouldRecreateSearch = !isViewWidgetsEqualForSearch(state.view, currentView) || !isViewSearchEqual(state.view.search, currentView.search);
  return dispatch(updateView(state.view, shouldRecreateSearch, { hasToPushRevision }));
});
export const undo = () => async (dispatch, getState) => {
  const rootState = getState();
  const { revisions, currentRevision } = selectRootUndoRedo(rootState);
  const { isUndoAvailable } = selectUndoRedoAvailability(rootState);
  const { view: currentView } = selectRootView(rootState);
  const hasToPushRevision = currentRevision === revisions.length;
  if (isUndoAvailable) {
    const newRevision = currentRevision - 1;
    const { state } = revisions[newRevision];
    viewHandler(state, { hasToPushRevision, dispatch, currentView }).then(
      () => dispatch(setCurrentRevision(newRevision))
    );
  }
};
export const redo = () => async (dispatch, getState) => {
  const rootState = getState();
  const { revisions, currentRevision } = selectRootUndoRedo(rootState);
  const { view: currentView } = selectRootView(rootState);
  const { isRedoAvailable } = selectUndoRedoAvailability(rootState);
  if (isRedoAvailable) {
    const newRevision = currentRevision + 1;
    const { state } = revisions[newRevision];
    viewHandler(state, { dispatch, hasToPushRevision: false, currentView }).then(
      () => dispatch(setCurrentRevision(newRevision))
    );
  }
};
